import { Form, FormItemProps, Radio, RadioGroupProps } from "antd";
import { FunctionComponent } from "react";

export type RadioValue = {
    value: any;
    label: string;
};

export type RadioGroupFormItemProps = RadioGroupProps & FormItemProps & {
    radioOptions: RadioValue[];
    testid?: string;
};

export const RadioGroupFormItem: FunctionComponent<RadioGroupFormItemProps> = ({ name, label, radioOptions, rules, testid, ...rest }) => {

    // Radio.Group strictly whitelists which attributes it forwards (aria-*/data-* only), so a bare
    // "testid" on it is silently dropped. Each individual Radio, however, forwards unknown props
    // straight to its underlying <input type="radio">, so we set testid there instead.
    const createRadio = (option: RadioValue) => {
        return <Radio key={option.value} value={option.value} {...({ testid: `${testid ?? name}-${option.value}` } as any)}>{option.label}</Radio>;
    }

    return (
        <Form.Item name={name.split(".")} label={label} rules={rules} >
            <Radio.Group {...rest}>
                {radioOptions.map(option => createRadio(option))}
            </Radio.Group>
        </Form.Item>
    );

}